import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVve = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M20 14.94 29 9l9 5.94V30H20z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M2 14.94 11 9l9 5.94V30H2z"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      d="M11 22H6v8h5z"
    />
    <path
      fill="#0061CD"
      d="M29 22h-5v8h5z"
    />
    <path
      fill="#00215B"
      d="m26.003 9.6 8.724 5.757.55-.835L26 8.4l-5.998 4-5.723-3.816-.554.832 6.277 4.185zM26.5 32.5V31h1v2.5h-20V31h1v1.5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVve);

export default ForwardRef;
